import { defineMessages } from 'react-intl';

export default defineMessages({
  checkboxLabel: {
    defaultMessage: 'Keep me signed in.',
    description: 'Label for keep me signed in checkbox',
    id: 'accountSignin.keepMeSignedIn.checkboxLabel',
  },
  screenreaderText: {
    defaultMessage: 'Learn about staying signed in',
    description:
      'Text added to details button for screenreaders to clarify usage',
    id: 'accountSignin.keepMeSignedIn.screenreaderText',
  },
  tooltipMessage: {
    defaultMessage:
      'Checking this box will reduce the number of times you’re asked to sign in. To keep your account secure, use this option only on your personal devices.',
    // eslint-disable-next-line max-len
    description: 'Tooltip message that tells user what the checkbox does',
    id: 'accountSignin.keepMeSignedIn.tooltipMessage',
  },
});
